export default __webpack_public_path__ + "assets/email.3a97cce4.svg";